import { defineComponent as _defineComponent } from 'vue'
import {reactive, onMounted} from 'vue';
import {database_set} from '@/api/login';
import {ElMessage} from 'element-plus';
import {register} from '@/api/account';
import i18n from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'new-user',
  emits: ['update'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;
const {t} = i18n.global;
// do not use same name with ref
const form = reactive({
	userName: '',
	passWord: '',
});

async function setting() {
	if (!/^[a-zA-Z]\w{2,19}$/.test(form.userName)) {
		ElMessage({
			message: t('account.formWarning'),
			type: 'warning',
		});

		emit('update', false);
		return false;
	}

	emit('update', true, form.userName, form.passWord);
}

const __returned__ = { emit, t, form, setting }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})